import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface DrawerAds {
  drawerVisible: boolean;
  drawerAdsSpecific: boolean;
  drawerUpdate: boolean | undefined;
  dataAd: any;
  currentCreneau: any;
  reportDrawerVisible: boolean;
  reportingUserData: any;
  reportedUserData: any;
}

const initialState: DrawerAds = {
  drawerVisible: false,
  drawerUpdate: false,
  drawerAdsSpecific: false,
  dataAd: {},
  currentCreneau: null,
  reportDrawerVisible: false,
  reportingUserData: {},
  reportedUserData: {},
};

export const drawerAdSlice = createSlice({
  name: "drawerAds",
  initialState,
  reducers: {
    displayDrawer: (state: any, action: PayloadAction<any>) => {
      state.drawerVisible = action.payload;
    },
    displayDrawerAdsSpecific: (state: any, action: PayloadAction<any>) => {
      state.drawerAdsSpecific = action.payload;
    },
    displayDrawerUpdate: (state: any, action: PayloadAction<any>) => {
      state.drawerUpdate = action.payload;
    },
    setDataUpdate: (state: any, action: PayloadAction<any>) => {
      state.dataAd = action.payload;
    },
    setCurrentCreneau: (state: any, action: PayloadAction<any>) => {
      state.currentCreneau = action.payload;
    },
    displayReportDrawer: (state: any, action: PayloadAction<any>) => {
      state.reportDrawerVisible = action.payload;
    },
    setReportingUserData: (state: any, action: PayloadAction<any>) => {
      state.reportingUserData = action.payload;
    },
    setReportedUserData: (state: any, action: PayloadAction<any>) => {
      state.reportedUserData = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  displayDrawer,
  displayDrawerAdsSpecific,
  displayDrawerUpdate,
  setDataUpdate,
  setCurrentCreneau,
  displayReportDrawer,
  setReportingUserData,
  setReportedUserData,
} = drawerAdSlice.actions;

export default drawerAdSlice.reducer;
